"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecorderEvents = void 0;
var _eventBuffer = require("../../utils/event-buffer");
class RecorderEvents {
  /** The buffer to hold recorder event nodes */
  #events = new _eventBuffer.EventBuffer(Infinity);
  /** Payload metadata -- Should indicate when a replay blob started recording.  Resets each time a harvest occurs.
     * cycle timestamps are used as fallbacks if event timestamps cannot be used
     */
  cycleTimestamp = Date.now();
  /** Payload metadata -- Should indicate that the payload being sent has a full DOM snapshot. This can happen
   * -- When the recording library begins recording, it starts by taking a DOM snapshot
   * -- When visibility changes from "hidden" -> "visible", it must capture a full snapshot for the replay to work correctly across tabs
  */
  hasSnapshot = false;
  /** Payload metadata -- Should indicate that the payload being sent has a meta node. The meta node should always precede a snapshot node. */
  hasMeta = false;
  /** Payload metadata -- Should indicate that the payload being sent contains an error.  Used for query/filter purposes in UI */
  hasError = false;
  /** Payload metadata -- Denotes whether all stylesheet elements were able to be inlined */
  inlinedAllStylesheets = true;
  add(event) {
    this.#events.add(event);
  }
  get events() {
    return this.#events.buffer;
  }

  /** A value which increments with every new mutation node reported. Resets after a harvest is sent */
  get payloadBytesEstimation() {
    return this.#events.bytes;
  }
}
exports.RecorderEvents = RecorderEvents;